module.exports = __webpack_public_path__ + "static/15-6b9f6243011ca87010342a86ce8a1ac4.jpg";